import { createBrowserRouter, Navigate } from 'react-router-dom';

import { LayoutPublisher } from 'app/layouts/LayoutPublisher/LayoutPublisher';
import { routerPublic } from 'app/router/RouterPublic';
import { NotFound } from 'pages/NotFound';
import {
	Clients,
	CreatePortfolio,
	Dashboard,
	Documents,
	Earnings,
	EditPortfolio,
	Offer,
	Portfolio,
	Task,
	Tasks,
} from 'pages/publisher';
import { EMainRoutes } from 'shared/typings';

export const routerPublisher = [
	{
		path: `/${EMainRoutes.PUBLISHER}`,
		element: <LayoutPublisher />,
		errorElement: <LayoutPublisher outlet={<NotFound />} />,
		children: [
			{
				path: '',
				element: <Dashboard />,
			},
			{
				path: EMainRoutes.DASHBOARD,
				element: <Dashboard />,
			},
			{
				path: EMainRoutes.CLIENTS,
				element: <Clients />,
			},
			{
				path: EMainRoutes.DOCUMENTS,
				element: <Documents />,
			},
			{
				path: EMainRoutes.EARNINGS,
				element: <Earnings />,
			},
			{
				path: EMainRoutes.TASKS,
				element: <Tasks />,
			},
			{
				path: `${EMainRoutes.OFFER}/:slug`,
				element: <Offer />,
			},
			{
				path: `${EMainRoutes.TASK}/:slug`,
				element: <Task />,
			},
			{
				path: EMainRoutes.PORTFOLIO,
				children: [
					{
						path: '',
						element: <Portfolio />,
					},
					{
						path: EMainRoutes.CREATE,
						element: <CreatePortfolio />,
					},
					{
						path: `${EMainRoutes.EDIT}/:slug`,
						element: <EditPortfolio />,
					},
				],
			},
			{
				path: '*',
				element: (
					<Navigate
						replace
						to={{ pathname: `/${EMainRoutes.PUBLISHER}/${EMainRoutes.DASHBOARD}`, search: window.location.search }}
					/>
				),
			},
		],
	},
	{
		path: '*',
		element: <Navigate replace to={{ pathname: `/${EMainRoutes.PUBLISHER}/`, search: window.location.search }} />,
	},
];

export const routerPublisherApp = createBrowserRouter([
	...routerPublisher,
	...routerPublic,
	{
		path: '*',
		element: <Navigate replace to={{ pathname: `/${EMainRoutes.PUBLISHER}/`, search: window.location.search }} />,
	},
]);
